import { render, staticRenderFns } from "./AboutAffiantAPSP.vue?vue&type=template&id=63865d2f"
import script from "./AboutAffiantAPSP.vue?vue&type=script&lang=ts"
export * from "./AboutAffiantAPSP.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports